const addUniqueMemberToList = (list,member) => {
    if (list.length > 0) {
        let foundElement = list.find(item => item.id === member.id)
        // Add Only when if user is not in the list
        if (!foundElement) {
            list.push({...member, newMessageSent:false})
        }
    }else{
        list.push({...member, newMessageSent:false})
    }

    return list;
}

const convertObjectToArray = (list) => {
    if (!list) return [];
    return Object.entries(list).map(([id, data]) => ({ id, data }));
}

export { addUniqueMemberToList, convertObjectToArray };